import { useNav } from "@/components/nav/NavProvider";

export type RecipeOrigin = "discover" | "recipes" | "calendar";

const VALID_ORIGINS: ReadonlySet<string> = new Set<RecipeOrigin>([
  "discover",
  "recipes",
  "calendar",
]);

export function useRecipeFrom(): RecipeOrigin | null {
  const { activeTab } = useNav();
  if (activeTab && VALID_ORIGINS.has(activeTab)) return activeTab as RecipeOrigin;
  return null;
}
